const records = 'vendors';

export default {
  records,
};
